import { module } from 'modujs';
import { gsap } from '../gsap'

export default class extends module {
    constructor(m) {
        super(m);

        this.$image = this.$('image')[0]
        this.$desc = this.$('desc')
        this.$desc = this.$desc.length > 0 ? this.$desc[0] : false
    }

    init() {
        this.setTimeline()

        // window.addEventListener('resizeEnd', this.onResize = () => this.resize())
    }

    setTimeline() {

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: 'top bottom',
                end: 'bottom bottom',
                scrub: 1,
                default: {
                    ease: 'power2.inOut'
                }
            },
        })

        this.tl
            .from(this.$image, {
                yPercent: -50,
            }, 0)

        if(this.$desc) {

            this.tl
                .from(this.$desc, {
                    y: 200
                }, 0)
        }
    }

    // resize() {
    //     this.tl.scrollTrigger.kill(true)
    //     this.tl.kill(true)

    //     const $elements = [this.$image]

    //     if(this.$desc) {
    //         $elements.push(this.$desc)
    //     }

    //     gsap.set($elements, {
    //         clearProps: 'all'
    //     })

    //     this.setTimeline()
    // }

    destroy() {
        this.tl.kill()

        // window.removeEventListener('resizeEnd', this.onResize)
    }
}
